import React from "react";

import "./index.css";

const readingPlan2025Updated =
  "https://www.dropbox.com/scl/fi/skk9chfgbxqw7gfbunjfj/2025-WAC-Reading-Plan-July-Dec.pdf?rlkey=fqegnzomxtml12f36arf5kfyy&st=piaf6twh&dl=1";

function ReadingPlanForTheYear() {
  return (
    <div className="DownloadReadingPlan__component">
      <a
        href={readingPlan2025Updated}
        download="wearechurchreadingPDF-2025"
        rel="noopener noreferrer"
      >
        <h3>2025 Reading Plan (July-Dec) PDF</h3>
      </a>
      <br />
    </div>
  );
}

export default ReadingPlanForTheYear;
